import React from 'react';

const SubtopicModal = ({ 
  isLoading, 
  subtopics, 
  randomUserInterest, 
  onSubtopicSelection, 
  onClose 
}) => {
  return (
    <div className="modal-overlay-subtopic-choice">
      <div className="modal-subtopic-choice">
        {/* Conditionally show Close Button only when not loading */}
        {!isLoading && (
          <button
            className="modal-close-button"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        )}

        {isLoading ? (
          <div className="modal-loading">
            <span className="loading-spinner medium"></span>
            <h2 style={{ color: "#405159" }}>Generating issues for you to choose from...</h2>
          </div>
        ) : (
          <>
            <h3 style={{ color: "#405159" }}>
              To continue to the discussion with Criticoach, select an issue related to your interest: "{randomUserInterest}".
            </h3>
            <ul className="subtopic-list">
              {subtopics.map((subtopic, index) => (
                <li key={index}>
                  <button
                    className="subtopic-button"
                    onClick={() => onSubtopicSelection(subtopic)}
                  >
                    {subtopic}
                  </button>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  );
};

export default SubtopicModal;
